import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { NumField, num } from "@/components/tools/ToolUI";

const FIELDS = [
  ["adg_base", "Ganancia diaria rodeo actual (kg/día)"],
  ["adg_brangus", "Ganancia diaria con Brangus (kg/día)"],
  ["intake_pct", "Consumo diario (% del peso vivo)"],
  ["feed_cost", "Costo del alimento (US$/kg)"],
  ["price_kg", "Precio de venta (US$/kg)"],
  ["heterosis_pct", "Heterosis cebú × Angus (% de mejora)"],
  ["taurus_weaning_pct", "Aporte del Angus al peso (% por 100% Angus)"],
  ["weaning_base", "Peso al destete cebú puro (kg)"],
  ["final_base", "Peso final cebú puro (kg)"],
  ["months_base", "Meses a terminación cebú puro"],
  ["precocity_months", "Meses menos a terminación por 100% Angus"],
];

export const AdminTools = () => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/tools/params").then((r) => setF(r.data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/admin/tools/params", Object.fromEntries(Object.entries(f).map(([k, v]) => [k, num(v)])));
      setF(data);
      toast.success("Valores de referencia guardados");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  if (!f) return null;
  return (
    <form onSubmit={submit} className="card-fv p-6 sm:p-8 max-w-3xl" data-testid="admin-tools">
      <p className="text-sm text-[#5C635E] mb-6">Valores que usan las calculadoras de la pestaña Herramientas como punto de partida.</p>
      <div className="grid gap-4 sm:grid-cols-2">
        {FIELDS.map(([k, label]) => <NumField key={k} id={`admin-tools-${k}`} label={label} value={f[k]} onChange={(v) => setF({ ...f, [k]: v })} />)}
      </div>
      <button disabled={busy} className="btn-fv btn-red mt-8 disabled:opacity-60" data-testid="admin-tools-save-button"><Save size={16} />{busy ? "Guardando…" : "Guardar"}</button>
    </form>
  );
};
